// Copyright (c) 2017 Deere & Company

import AddClaimsToAudit from '../../tcsm/claim-search/state-connector';

export default {
    component: AddClaimsToAudit,
    name: 'ADD_CLAIMS',
    path: 'claims'
};



// WEBPACK FOOTER //
// ./src/routes/tcsm/audit-add-claims.js